<template>
  <div>
    <div class="col__box categories_with_movies" v-for="category in categoriesWithMovies" :key="category.slug">
      <router-link :to="{name: 'movies.index', query: {categories: category.slug}}" class="float-right view-more" :title="$t('view-more')">{{$t('view-more')}}</router-link>
      <h2><span class="title">{{$t(category.name)}}</span></h2>
      <carousel :autoplay="true" :perPage="6" v-if="category.top_movies">
        <slide v-for="movie in category.top_movies" :key="movie.slug">
          <movie-item-vertical-component v-bind:movie="movie"/>
        </slide>
      </carousel>
      <loading-component v-else />
    </div>
  </div>
</template>
<script>
'use strict';
import {Carousel, Slide} from "vue-carousel";
import Helper from '@/Helper';
import MovieItemVertical from '@/components/movie-item-vertical';
export default {
  name: 'index',
  components: {
    'movie-item-vertical-component': MovieItemVertical,
    carousel: Carousel,
    slide: Slide,
    ...Helper.loadComponents([
      'loading',
    ]),
  },
  data() {
    return {

    };
  },
  watch: {
    categories() {
      this.getMovies();
    },
    $route() {
      this.getMovies();
    }
  },
  mounted() {
    this.getMovies();
  },
  created() {
    this.setTitle('');
  },
  methods: {
    async getMovies() {
      if (!this.categories || !Array.isArray(this.categories.data)) {
        return;
      }

      this.$store.commit('fetchCategoriesWithMovies');
    }
  },
  computed: {}
};

</script>
